import { isNapflixOSMode } from "./napflixOS";

// NapflixOS Media Session Manager v10
// Central runtime media state foundation. No player integration yet.
const emptyMediaSession = {
  source: null,
  type: null,
  title: null,
  subtitle: null,
  artwork: null,
  channel: null,
  ratingKey: null,
  playing: false,
  paused: false,
  buffering: false,
  muted: false,
  volume: null,
  position: null,
  duration: null,
  updatedAt: Date.now(),
  originPage: null,
  originRoute: null,
};

let mediaSession = { ...emptyMediaSession };
const listeners = new Set();

const notifyListeners = () => {
  listeners.forEach((listener) => listener(mediaSession));
};

export function getMediaSession() {
  return mediaSession;
}

export function setMediaSession(partial) {
  mediaSession = {
    ...mediaSession,
    ...partial,
    updatedAt: Date.now(),
  };

  notifyListeners();
  return mediaSession;
}

export function subscribeMediaSession(listener) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function clearMediaSession() {
  mediaSession = {
    ...emptyMediaSession,
    updatedAt: Date.now(),
  };

  notifyListeners();
  return mediaSession;
}

export function setMediaPlaying(session) {
  return setMediaSession({
    ...session,
    playing: true,
    paused: false,
    buffering: false,
  });
}

export function setMediaPaused(partial = {}) {
  return setMediaSession({
    ...partial,
    playing: false,
    paused: true,
    buffering: false,
  });
}

export function setMediaBuffering(partial = {}) {
  return setMediaSession({
    ...partial,
    buffering: true,
  });
}

export function updateMediaProgress(position, duration) {
  return setMediaSession({
    position,
    duration,
  });
}

export function setMediaMuted(muted) {
  return setMediaSession({ muted: !!muted });
}

export function setMediaVolume(volume) {
  const nextVolume = Number(volume);

  return setMediaSession({
    volume: Number.isFinite(nextVolume)
      ? Math.min(1, Math.max(0, nextVolume))
      : mediaSession.volume,
  });
}

if (typeof window !== "undefined" && isNapflixOSMode()) {
  window.NAPFLIX_MEDIA_SESSION = {
    getMediaSession,
    setMediaSession,
    clearMediaSession,
  };
}
